// App
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

// Hooks
import { useHighlights } from './hooks';

// Components
import SrpContentWrapper from 'app/shared/modules/MobileSRP/__BaseComponents__/SrpContentWrapper';

// Misc / utils
import * as S from './styles';
import type { RootReduxState } from 'app/shared/flux/reducers';
import type Facts from 'app/shared/models/Facts';

const MarketHighlights = () => {
  // Redux
  const highlightsData = useSelector((state: RootReduxState) => state.area.facts);

  // Hooks
  const { parsedHighlights } = useHighlights(highlightsData as InstanceType<typeof Facts>);

  if (parsedHighlights.length < 1) {
    return null;
  }

  return (
    <SrpContentWrapper identifier={'market-highlights'} title={'Market highlights'}>
      <section>
        {parsedHighlights.map((fact) => {
          const label = fact.label;
          const value = fact.value;

          return (
            <Fragment key={`demographic-${fact.label}-fact-${fact.value}-answer`}>
              <S.Label>{label}</S.Label>
              <S.Value>{value}</S.Value>
            </Fragment>
          );
        })}
      </section>
    </SrpContentWrapper>
  );
};

export default MarketHighlights;
